// extracted by mini-css-extract-plugin
module.exports = {"title":"License_title__1b7Ra","name":"License_name__3dpMa","invoiceField":"License_invoiceField__3dWow"};